/**
 * Resolve the correct portal landing path for a restored/authenticated user.
 *
 * Used by the native cold-start session-restore flow (App.js RootRoute) so a
 * logged-in user is routed straight to their portal instead of being stranded
 * on the public marketing page (Samsung S21 QA 2026-07-20).
 */
const ADMIN_ROLES = ["admin", "master_admin", "super_admin", "admin_support_readonly"];

export const portalPathForUser = (user) => {
  const role = user?.role;
  if (ADMIN_ROLES.includes(role)) return "/admin";
  if (role === "vendor" || user?.vendor_id) return "/vendor";
  return "/dashboard";
};

export default portalPathForUser;
